import { APP_INITIALIZER, NgModule, Inject, inject } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { BrowserModule } from '@angular/platform-browser'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NavbarComponent } from './components/navbar/navbar.component'
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader'
import { FooterComponent } from './components/footer/footer.component'
import { SettingService } from './pages/admin/setting.service'
import { catchError, tap } from 'rxjs/operators'
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';
import { ForbiddenComponent } from './pages/forbidden/forbidden.component'
import { AuthInterceptorService } from './pages/auth/auth-interceptor.service';
import { HomeDarkComponent } from './module/web_dark/pages/home/home.component'
import { NavbarDarkComponent } from './module/web_dark/components/navbar/navbar.component'
import { ErrorInterceptor } from './helpers/service/error.interceptor';
import { TokenInterceptor } from './helpers/service/token.interceptor'
import { SidebarComponent } from './components/sidebar/sidebar.component'

@NgModule({
  declarations: [AppComponent, ForbiddenComponent],
  imports: [
    BrowserModule,
    FooterComponent,
    NavbarComponent,
    NgxSkeletonLoaderModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HomeDarkComponent,
    NavbarDarkComponent,
    SidebarComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true
    },
    {
      provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        let settingService = inject(SettingService)
        const http = inject(HttpClient)
        return () =>
          new Promise((resolve) => {
            //load setting for deployment
            if (environment.production) {
              http
                .get('./config.json')
                .pipe(
                  tap((data: any) => {
                    settingService.baseUrl = data.baseUrl
                    resolve(true)
                  }),
                  catchError((error) => {
                    settingService.baseUrl = 'http://localhost:5000'
                    return of(null)
                  })
                )
                .subscribe()
            } else {
              //load for local
              const setting = require('../../config.json')
              settingService.baseUrl = setting.baseUrl
              resolve(true)
            }
          })
      },
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
